const state = {
  processing: false,
  data: null,
};

export default state;
